import { handleActions } from 'redux-actions';
import { combineReducers } from 'redux';
import { setGroupName } from './actions';

const nameReducer = handleActions(
  {
    [setGroupName.toString()]: (_, { payload: name }) => name
  },
  ''
);

export default combineReducers({
  name: nameReducer
});
